import type { ParsedUrlQuery } from 'querystring';
import { isDefined } from '@peloton/types/isDefined';
import {
  TAGS_VIEW_PARAM,
  TAG_NAME_PARAM,
  TAG_BROWSE_CATEGORY_PARAM,
} from '@engage/tags/shared';
import { TagModalView } from './shared';

export const getTagNameFromLocation = (query: ParsedUrlQuery) =>
  query?.[TAG_NAME_PARAM] as string | undefined;

export const getTagViewFromLocation = (query: ParsedUrlQuery) => {
  const tagViewParam = getTagViewParamFromLocation(query);
  if (isDefined(tagViewParam)) {
    return toTagModalView(tagViewParam.toLowerCase());
  } else {
    return undefined;
  }
};

const getTagViewParamFromLocation = (query: ParsedUrlQuery) =>
  query?.[TAGS_VIEW_PARAM] as string | undefined;

const toTagModalView = (view: string) => {
  const values = Object.keys(TagModalView).map(k => ({
    k,
    // @ts-expect-error (TS7053): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'typeof TagModalView'.
    v: TagModalView[k].toLowerCase(),
  }));
  const found = values.find(({ v }) => view === v);
  // @ts-expect-error (TS7053): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'typeof TagModalView'.
  return found ? TagModalView[found.k] : TagModalView.BrowseTags;
};

export const getLastTagView = (query: ParsedUrlQuery) => {
  const stack = query?.viewStack ?? [];
  return stack.length > 0 ? stack[stack.length - 1] : undefined;
};

export const getTagBrowseCategoryFromLocation = (query: ParsedUrlQuery) =>
  query?.[TAG_BROWSE_CATEGORY_PARAM] as string | undefined;
